import { IChildrenProp } from "types/components/components.interface";
import "./ContractHeader.scss";

interface ContractHeaderProps extends IChildrenProp {}

const ContractHeader = ({ children }: ContractHeaderProps) => {
  return <div className="contract-header-wrapper">{children}</div>;
};

export default ContractHeader;
